<template>
  <user-center-wrap>
    <div class="private-chat">
      <div class="title">聊天消息</div>
      <div class="empty" v-show="chatListFilter.length === 0">
        <img src="@/assets/img/empty/no-data.png" alt="" />
        <div>什么也没有</div>
      </div>
      <div class="content" v-show="chatListFilter.length > 0">
        <div class="anchors">
          <div :class="['anchor', anchorActive === item.uniq_id ? 'anchor-active' : '']" @click="changeTab(item.uniq_id, index)" v-for="(item, index) in chatListFilter" :key="index">
            <img src="./img/live.png" alt="" class="live" v-show="item.is_online && item.mgr_chat_user_id === 0 && item.mgr_id === 0" />
            <img src="./img/off-line.png" alt="" class="live" v-show="!item.is_online && item.mgr_chat_user_id === 0 && item.mgr_id === 0" />
            <div class="live manager" v-show="item.mgr_chat_user_id === userInfo.id">房管</div>
            <img :src="item.avatar ? item.avatar : require('@/assets/img/default/default_logo1.png')" alt="" class="avatar" />
            <div class="anchor-desc">
              <div class="up">
                <div class="name text-overflow">{{ item.name }}</div>
                <div class="time" v-show="item.type === 1">{{ item.chat_time }}</div>
                <div class="group" v-show="item.type === 0">
                  <img src="./img/group.png" alt="" />
                  <div>{{ item.user_num }}</div>
                </div>
              </div>
              <div class="down">
                <div class="msg text-overflow" v-show="item.type === 1">{{ item.private_chat_latest_msg.latest_msg }}</div>
                <div class="msg" v-show="item.type === 0">群ID：{{ item.anchor_id }}</div>
                <div class="msg" v-show="item.type === 2"></div>
                <div class="note" v-show="item.unread_num">{{ item.unread_num > 99 ? "99+" : item.unread_num }}</div>
              </div>
            </div>
          </div>
        </div>
        <Chatbox v-if="type === 0" ref="chatbox" @openAnchorInfo="openAnchorInfo" @toUserChat="toUserChat" @delGroupChangeTab="delGroupChangeTab" />
        <ChatboxPrivate v-if="type === 1" :chatInfo="chatInfo" />
        <ChatboxUser v-if="type === 2" />
        <AnchorInfoUserCenter
          v-if="isAnchorInfo"
          ref="anchorInfo"
          @toPrivateChat="toPrivateChat"
          @closeAnchorInfo="closeAnchorInfo"
          @toGroupInfo="toGroupInfo"
          @toGroupChat="toGroupChat"
          @joinGroup="joinGroup"
        />
      </div>
    </div>
  </user-center-wrap>
</template>

<script>
import UserCenterWrap from "@/components/user-center-wrap/user-center-wrap";
import Chatbox from "@/components/chat-box/chat-box";
import ChatboxPrivate from "@/components/chat-box-private/chat-box-private";
import ChatboxUser from "@/components/chat-box-user/chat-box-user";
import AnchorInfoUserCenter from "@/components/anchor-info/anchor-info-usercenter";
import { post } from "@/util/http";
import moment from "moment";
import { mapState, mapMutations, mapActions } from "vuex";
import Cipboard from "clipboard";
import { format } from "@/util/time";
import TIM from "tim-js-sdk";
import { tim, timJoinGroup } from "@/util/tim";

export default {
  components: {
    UserCenterWrap,
    Chatbox,
    AnchorInfoUserCenter,
    ChatboxUser,
    ChatboxPrivate,
  },
  data() {
    return {
      visible: false,
      anchorActive: 0,
      errorMessageIds: [],
      messageContent: "",
      chatInfo: {},
      loading: true,
      isListDataLoaded: false,
      type: 0,
      isAnchorInfo: false,
      chatListOnce: true,
      listIndex: 0,
    };
  },
  computed: {
    ...mapState(["userInfo", "chatList", "privateMessageList", "anchorId", "anchorInfo", "isFollowed"]),
    chatListFilter() {
      return this.chatList.filter((e) => e.anchor_id !== this.userInfo.id);
    },
  },
  props: {},

  watch: {
    privateMessageList(newVal) {
      let lastMsg = newVal[newVal.length - 1];
      console.log(lastMsg, this.chatList, "newMsg");
      this.chatList.forEach((e) => {
        if (e.anchor_id === lastMsg?.sender_uid || e.anchor_id === lastMsg?.receive_uid) {
          e.private_chat_latest_msg.latest_msg = lastMsg.content;
        }
      });
    },
    chatList: {
      handler(newVal) {
        console.log("newVal chatList", newVal, this.chatListOnce);
        if (newVal.length === 0 || this.anchorActive === -1 || !this.chatListOnce) return;
        let filter = newVal.filter((e) => e.anchor_id !== this.userInfo.id);
        let chat = filter[0] || {};
        this.anchorActive = chat.uniq_id;
        this.type = chat?.type;
        this.changeAnchorId(chat.anchor_id);
        if (this.type === 0) {
          this.changeFanGroup(chat);
          this.getGroupHistory();
          this.getGroupInfo();
        }
        if (this.type === 1) {
          this.changeIsEnterPrivateChat(true);
          this.getPrivateHistory();
        }
        if (this.type === 2) {
          if (chat.mgr_id === this.userInfo.id) {
            this.changeUserChatId(chat.mgr_chat_user_id);
          } else {
            this.changeUserChatId(chat.mgr_id);
          }
          this.changeUserChatName(chat.name);
        }
        this.chatListOnce = false;
      },
      immediate: true,
    },
  },
  destroyed() {
    this.changeIsEnterPrivateChat(false);
  },
  mounted() {
    document.addEventListener("visibilitychange", this.changeBrowserTab, false);
  },
  methods: {
    ...mapMutations([
      "changeUserInfo",
      "toggleLogin",
      "pushToast",
      "changePrivateMessageList",
      "changeGroupMessageList",
      "changeFanGroup",
      "changeAnchorId",
      "changeUserChatId",
      "changeUserChatName",
      "changeUserMessageList",
      "changeUserChatName",
      "changeNoMoreMsg",
      "changeIsEnterPrivateChat",
    ]),
    ...mapActions(["getChatList", "getAnchorProfile", "addToGroupChat", "onFollow", "getPrivateHistory", "getUserHistory", "getGroupHistory", "getGroupInfo"]),

    changeTab(chatlistId, index) {
      const item = this.chatListFilter.filter((e) => e.uniq_id === chatlistId)[0];
      console.log(item, chatlistId, "changeTab=================================================");
      this.anchorActive = chatlistId;
      this.listIndex = index;
      this.changeNoMoreMsg(false);
      this.changePrivateMessageList([]);
      this.changeGroupMessageList([]);
      this.changeUserMessageList([]);
      this.chatInfo = item;
      this.isAnchorInfo = false;
      this.type = -1;
      setTimeout(() => {
        this.changeAnchorId(item.anchor_id);
        this.type = item.type;
        if (item.type === 0) {
          this.changeFanGroup(item);
          this.getGroupHistory();
          this.getGroupInfo();
        }
        if (item.type === 1) {
          this.isAnchorInfo = false;
          this.changeIsEnterPrivateChat(true);
          this.getPrivateHistory();
        } else {
          this.changeIsEnterPrivateChat(false);
        }
        if (item.type === 2) {
          if (item.mgr_id === this.userInfo.id) {
            this.changeUserChatId(item.mgr_chat_user_id);
            this.getUserHistory({ uid: item.mgr_chat_user_id });
          } else {
            this.changeUserChatId(item.mgr_id);
            this.getUserHistory({ uid: item.mgr_id });
          }
          this.changeUserChatName(item.name);
        }
      }, 100);
    },
    changeBrowserTab(event) {
      if (document.visibilityState === "visible") {
        console.log("选中浏览器Tab：：：：：：：：：：：：：：：：");
        this.getChatList();
      }
    },
    delGroupChangeTab() {
      let filter = this.chatListFilter[this.listIndex + 1];
      console.error(filter, "del");
      this.changeTab(filter.uniq_id);
    },
    toUserChat(item) {
      console.log(item, "toUserChat");
      let id = item.id || item.uid;
      const arr = this.chatListFilter.find((e) => e.mgr_chat_user_id === id);
      console.log(item, arr, "toUserChat");
      if (arr === undefined) {
        this.anchorActive = "";
      } else {
        this.anchorActive = arr.uniq_id;
      }
      this.type = 2;
      this.changeUserChatId(id);
      this.changeUserChatName(item.nick_name);
      this.getUserHistory({ uid: id });
    },

    toGroupChat(group) {
      console.log(group, "toGroupChat");
      if (this.userInfo.id === this.anchorId) {
        this.pushToast("主播不能进自己的粉丝群哦，您可以换一个号进去");
        return;
      }
      if (!group.is_joined) {
        this.pushToast("请先加入群聊");
        return;
      }
      this.changeGroupMessageList([]);
      this.changeFanGroup(group);
      this.anchorActive = this.chatList.findIndex((e) => e.fans_group_id === group.fans_group_id);
      group.type = 0;
      this.changeTab(this.anchorActive);
      this.isAnchorInfo = false;
    },
    toGroupInfo(group) {
      if (this.userInfo.id === this.anchorId) {
        this.pushToast("主播不能进自己的粉丝群哦，您可以换一个号进去");
        return;
      }
      if (!group.is_joined) {
        this.pushToast("请先加入群聊");
        return;
      }
      this.changeFanGroup(group);
      this.anchorActive = this.chatList.findIndex((e) => e.fans_group_id === group.fans_group_id);
      this.isAnchorInfo = false;
      this.$refs.chatbox.toGroupInfo();
    },
    async joinGroup(group) {
      console.log(group);
      if (this.isFollowed === 0) {
        this.onFollow();
      }
      let res = await this.addToGroupChat(group.group_id);
      console.log("res", res);
      if (res === "SUCCESS") {
        this.getChatList();
        this.getAnchorProfile(this.anchorId);
      }
    },
    toPrivateChat() {
      this.isAnchorInfo = false;
      this.anchorActive = this.chatList.findIndex((e) => e.anchor_id === this.anchorId && e.type === 1) || -1;
      this.type = 1;
      this.chatInfo = this.anchorInfo;
    },
    closeAnchorInfo() {
      this.isAnchorInfo = false;
    },
    openAnchorInfo(anchorId) {
      this.changeAnchorId(anchorId);
      this.getAnchorProfile(anchorId);
      this.isAnchorInfo = true;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    // height: 5.74rem;
  }
  .el-dialog {
    width: 3.55rem;
    height: 1.96rem;
    border-radius: 0.1rem;
  }
}
.first-gift {
  height: 1.96rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 0.2rem 0;
  .row1 {
    color: #333333;
    font-weight: 500;
    font-size: 0.2rem;
  }
  .row2 {
    width: 2.5rem;
    text-align: center;
    line-height: 0.23rem;
  }
  .row3 {
    display: flex;
    align-items: center;
    justify-content: center;
    .btn {
      width: 1.12rem;
      height: 0.34rem;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666666;
      font-size: 0.16rem;
      color: #02a8a2;
      border: 1px solid #02a8a2;
      border-radius: 1rem;
      cursor: pointer;
    }
    .btn-active {
      background: #02a8a2;
      color: #ffffff;
      margin-left: 0.24rem;
    }
  }
}

.private-chat {
  padding: 0.28rem 0.44rem;
  .title {
    font-weight: 500;
    font-size: 0.2rem;
    margin-bottom: 0.32rem;
  }
  .empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 20vh;
    color: #999999;
    font-size: 0.16rem;
    img {
      width: 2.7rem;
      margin-bottom: 0.2rem;
    }
  }
  .content {
    width: 9rem;
    height: 8.8rem;
    border-radius: 0.05rem;
    background: #f9f9fb;
    display: flex;
    color: #333333;
    .anchors {
      width: 3rem;
      height: 8.8rem;
      overflow: scroll;
      // box-shadow: inset -0.5px 0px 0px rgba(0, 0, 0, 0.2);
      border-right: 0.5px solid #eee;
      .anchor {
        height: 0.8rem;
        display: flex;
        padding: 0.12rem;
        box-shadow: inset 0px -0.5px 0px #eeeeee;
        cursor: pointer;
        position: relative;
        .live {
          width: 0.46rem;
          height: 0.16rem;
          position: absolute;
          bottom: 0.1rem;
          left: 0.13rem;
        }
        .manager {
          width: 0.56rem;
          height: 0.2rem;
          text-align: center;
          line-height: 0.2rem;
          border-radius: 0.2rem;
          background: #02a8a2;
          color: #ffffff;
          font-size: 0.12rem;
          transform: scale(0.82);
          left: 0.1rem;
        }
        .avatar {
          width: 0.5rem;
          height: 0.5rem;
          border-radius: 0.5rem;
          margin-right: 0.06rem;
        }
        .anchor-desc {
          display: flex;
          flex-direction: column;
          justify-content: center;
          flex: 1;
          .up {
            display: flex;
            justify-content: space-between;
            margin-bottom: 0.08rem;
            .name {
              width: 1.47rem;
              font-size: 0.14rem;
              font-weight: 500;
            }
            .time {
              color: #999999;
              font-size: 0.12rem;
            }
            .group {
              display: flex;
              align-items: center;
              color: #999999;
              font-size: 0.12rem;
              img {
                width: 0.16rem;
                height: 0.16rem;
                margin-right: 0.04rem;
              }
            }
          }
          .down {
            display: flex;
            justify-content: space-between;
            .msg {
              font-size: 0.12rem;
              color: #666666;
              flex: 1;
            }
            .note {
              padding: 0 0.05rem;
              min-width: 0.2rem;
              height: 0.2rem;
              line-height: 0.2rem;
              text-align: center;
              border-radius: 0.2rem;
              background: #f64d5c;
              color: #ffffff;
              font-size: 0.12rem;
              margin-right: 0.04rem;
            }
          }
        }
      }
      .anchor-active {
        background: linear-gradient(90deg, rgba(41, 241, 156, 0.15) 0%, rgba(2, 161, 249, 0.15) 100%);
      }
    }
    .chat-box {
      width: 6rem;
      display: flex;
      flex-direction: column;
      .chat-box-header {
        padding: 0.16rem;
        height: 0.52rem;
        background: #f4f4f4;
        box-shadow: inset 0px -0.5px 0px rgba(0, 0, 0, 0.2);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          font-weight: 500;
          font-size: 0.16rem;
        }
        .right {
          font-size: 0.12rem;
          color: #666666;
          cursor: pointer;
        }
      }
      .chat-box-content {
        flex: 1;
        padding: 0.08rem 0.12rem;
        overflow-y: auto;
        /*火狐下隐藏滚动条*/
        scrollbar-width: none;
        .chat-time {
          text-align: center;
          margin-bottom: 0.12rem;
          color: #999;
          font-size: 0.12rem;
        }
        .chat-anchor {
          display: flex;
          align-items: flex-end;
          line-height: 0.2rem;
          margin-bottom: 0.16rem;

          .avatar {
            width: 0.28rem;
            height: 0.28rem;
            border-radius: 0.28rem;
            margin-right: 0.08rem;
          }
          .msg {
            max-width: 2.84rem;
            padding: 0.05rem 0.12rem;
            background: #ffffff;
            border-radius: 0.1rem 0.1rem 0.1rem 0px;
            position: relative;
            .nickname {
              color: #8393bc;
            }
            .angle {
              width: 0.07rem;
              position: absolute;
              left: -0.07rem;
              bottom: 0;
            }
          }
        }
        .chat-user {
          display: flex;
          justify-content: flex-end;
          align-items: flex-end;
          line-height: 0.2rem;
          margin-bottom: 0.16rem;
          .msg {
            max-width: 2.84rem;
            padding: 0.05rem 0.12rem;
            background: rgba(2, 168, 162, 0.2);
            border-radius: 0.1rem 0.1rem 0px 0.1rem;
            position: relative;
            .angle {
              width: 0.07rem;
              position: absolute;
              right: -0.07rem;
              bottom: 0;
            }
            .red-dot {
              position: absolute;
              top: 0.08rem;
              left: -0.2rem;
              background: #db6372;
              width: 0.16rem;
              height: 0.16rem;
              border-radius: 0.16rem;
              line-height: 0.16rem;
              text-align: center;
              color: #ffffff;
              margin-right: 0.04rem;
              cursor: pointer;
            }
          }
          .avatar {
            width: 0.28rem;
            height: 0.28rem;
            border-radius: 0.28rem;
            margin-left: 0.08rem;
          }
        }
      }
      .chat-box-message {
        height: 1.5rem;
        background: #f4f4f4;
        box-shadow: inset 0px 0.5px 0px rgba(0, 0, 0, 0.2);
        padding: 0.12rem;
        position: relative;
        textarea {
          width: 100%;
          border: none;
          background: #f4f4f4;
          color: #333333;
        }
        .btn {
          position: absolute;
          right: 0.16rem;
          bottom: 0.16rem;
          width: 1rem;
          height: 0.42rem;
          background: #02a8a2;
          border-radius: 0.05rem;
          font-size: 0.16rem;
          color: #ffffff;
          text-align: center;
          line-height: 0.42rem;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
